import React, { useRef, useState, PureComponent } from "react";

import NumericLabel from "react-pretty-numbers";

import numeral from "numeral";
import Select from "react-select";

import styles from "./style.module.css";

import { Button, ButtonGroup } from "aible";

import { Popover, OverlayTrigger, Overlay } from "react-bootstrap";

import { colors as nextColors } from "containers/Next/NextReducer";

import VotingIcon from "images/Next-Icons/model-voting.svg";

export default class DashboardHeatmap extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  getIsNumeric() {
    const { dataset } = this.props;

    const outcome = dataset?.outcome;
    const oField = dataset?.fields?.[outcome];

    return oField?.type === "number";
  }

  renderIcon() {
    const { chart } = this.props;

    const background = chart?.color ?? "grey";

    const rHexSize = 30;

    return (
      <div
        className={styles.hexagon + " " + styles.hIcon}
        style={{
          height: rHexSize - 3 + "px",
          width: (rHexSize - 3) * (110 / 190) + "px",
          marginLeft: "10px",
          background: background
        }}
      >
        <div className={styles.face1 + " " + styles.hIcon} style={{ background: background }}></div>
        <div className={styles.face2 + " " + styles.hIcon} style={{ background: background }}></div>
        <img src={VotingIcon} style={{ transform: "scale(0.5)" }} />
      </div>
    );
  }

  render() {
    const { chart } = this.props;

    const isNumeric = this.getIsNumeric();

    let rChart = {};
    let rChartScaled = {};
    let rModels = {};
    let rValues = {};

    let maxY = -9999;

    const maxValues = {
      max: 1,
      min: -1
    };

    chart?.data.forEach((row) => {
      if (rModels[row.y_name] === undefined) {
        rModels[row.y_name] = true;
      }
      if (rValues[row.x_name] === undefined) {
        rValues[row.x_name] = true;
      }

      if (rChart[row.x_name] === undefined) {
        rChart[row.x_name] = {};
      }

      if (rChartScaled[row.x_name] === undefined) {
        rChartScaled[row.x_name] = {};
      }

      rChart[row.x_name][row.y_name] = row.y;
      rChartScaled[row.x_name][row.y_name] = row.scaled_y;

      if (maxY < Math.abs(row.y)) {
        maxY = Math.abs(row.y);
      }

      if (isNumeric) {
        const columnAverage = row?.[`Average ${row?.column}`];

        chart?.lineKeys?.forEach((lKey) => {
          const averageDiff = (row[lKey] - columnAverage) / (Math.abs(columnAverage) || 1);
          if (maxValues.max === undefined) {
            maxValues.max = averageDiff;
          } else {
            maxValues.max = Math.max(averageDiff, maxValues.max);
          }
          if (maxValues.min === undefined) {
            maxValues.min = averageDiff;
          } else {
            maxValues.min = Math.min(averageDiff, maxValues.min);
          }
        });
      }
    });

    const values = Object.keys(rValues).map((vKey) => vKey);

    return (
      <div className={styles.dashboardHeatmap}>
        <div className={styles.heatmapGrid}>
          <div
            key={"first"}
            className={styles.dashValueRow}
            style={{
              minHeight: 100 / (chart.data.length + 1) + "%"
            }}
          >
            <div className={styles.dashValueName} title={chart?.data?.[0].column}>
              <div className={styles.dashValueNameText}>{chart?.data?.[0].column}</div>
            </div>
            <div
              className={styles.dashValues}
              style={{
                width: "100%"
              }}
            >
              {Object.keys(chart?.data?.[0])
                .filter((c) => chart.lineKeys.indexOf(c) !== -1)
                .map((d, j) => {
                  return (
                    <OverlayTrigger
                      key={"first" + "_" + j}
                      placement="top"
                      trigger={["hover"]}
                      rootClose
                      animation={false}
                      overlay={
                        <Popover id="popover-positioned-top">
                          <div className={styles.popItem}>
                            <div className={styles.popFirst}>{chart?.data?.[0].column + ":"}</div>
                            <div className={styles.popSecond}>{d}</div>
                          </div>
                        </Popover>
                      }
                    >
                      <div
                        className={styles.dashGridCellColumnLabel}
                        style={{ minWidth: `${100 / chart.lineKeys.length}%` }}
                      >
                        {d}
                      </div>
                    </OverlayTrigger>
                  );
                })}
            </div>
          </div>
          {chart?.data.map((chartData, i) => {
            return <HeatmapRow chartData={chartData} chart={chart} isNumeric={isNumeric} maxValues={maxValues} />;
          })}
        </div>
      </div>
    );
  }
}

const HeatmapRow = ({ chart, chartData, isNumeric, maxValues }) => {
  const tooltipAnchorRef = useRef(null);

  return (
    <div
      className={styles.dashValueRow}
      style={{
        minHeight: 100 / (chart.data.length + 1) + "%"
      }}
    >
      <HeatmapRowLabel
        chart={chart}
        chartData={chartData}
        isNumeric={isNumeric}
        maxValues={maxValues}
        tooltipAnchorRef={tooltipAnchorRef}
      />
      <div className={styles.dashValues} style={{ width: "100%" }}>
        {Object.keys(chartData)
          .filter((c) => chart.lineKeys.indexOf(c) !== -1)
          .map((d, j) => {
            return (
              <HeatmapCell
                data={d}
                chartData={chartData}
                maxValues={maxValues}
                isNumeric={isNumeric}
                chart={chart}
                tooltipAnchorRef={tooltipAnchorRef}
              />
            );
          })}
      </div>
    </div>
  );
};

const HeatmapRowLabel = ({ chart, chartData, selectedData, isNumeric, maxValues, tooltipAnchorRef }) => {
  const columnAverage = chartData?.[`Average ${chartData?.column}`];

  const rawScore = chartData[selectedData];

  let retScore = rawScore / 100;
  let adjustedScore = retScore;

  if (isNumeric) {
    if (rawScore !== 0) {
      retScore = (rawScore - columnAverage) / (Math.abs(columnAverage) || 1);
      if (retScore < 0) {
        adjustedScore = retScore / Math.abs(maxValues.min);
      } else {
        adjustedScore = retScore / Math.abs(maxValues.max);
      }
    }
  }

  return (
    <OverlayTrigger
      placement="left"
      trigger={["hover"]}
      animation={false}
      overlay={
        <Popover id="popover-positioned-top" title={chart?.data?.[0].column + ": " + chartData.name}>
          <div className={styles.popItem}>
            <div className={styles.popFirst}>{"Average:"}</div>
            <div className={styles.popSecond}>{columnAverage}</div>
          </div>
        </Popover>
      }
    >
      <div className={styles.dashValueName} title={chartData.column} ref={tooltipAnchorRef}>
        <div className={styles.dashValueNameText}>{chartData.name}</div>
      </div>
    </OverlayTrigger>
  );
};

const HeatmapCell = ({ data, chartData, chart, maxValues, isNumeric, tooltipAnchorRef }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const column = chartData.name;
  const columnName = chartData.column;
  const columnCount = chartData?.count;
  const columnAverage = chartData?.[`Average ${chartData?.column}`];

  const value = data;

  const rawScore = chartData[data];

  let retScore = rawScore / 100;
  let adjustedScore = retScore;

  if (isNumeric) {
    if (rawScore !== 0) {
      retScore = (rawScore - columnAverage) / (Math.abs(columnAverage) || 1);
      if (retScore < 0) {
        adjustedScore = retScore / Math.abs(maxValues.min);
      } else {
        adjustedScore = retScore / Math.abs(maxValues.max);
      }
    }
  }

  const baseColor =
    retScore === undefined && !isNumeric
      ? "rgba(125, 105, 215, 1)"
      : retScore > 0
        ? "rgba(125, 105, 215, 1)"
        : "rgba(213, 107, 39, 1)";

  return (
    <React.Fragment>
      <Overlay placement="left" show={showTooltip} target={tooltipAnchorRef.current} animation={false}>
        <Popover id="popover-positioned-top" title={column + ": " + value}>
          {isNumeric ? (
            <div className={styles.heatmapTooltipWrapper}>
              <div className={styles.heatmapTooltipWrapperItem}>
                <div className={styles.heatmapTooltipWrapperItemFirst}>{"Average: "}</div>
                <div className={styles.heatmapTooltipWrapperItemSecond}>{rawScore}</div>
              </div>
              <div className={styles.heatmapTooltipWrapperItem}>
                <div className={styles.heatmapTooltipWrapperItemFirst}>
                  {`Change from Average ${columnName} is ${column}:`}
                </div>
                <div className={styles.heatmapTooltipWrapperItemSecond}>
                  {numeral(retScore * 100).format("0.[00]") + "%"}
                </div>
              </div>
              <div className={styles.heatmapTooltipWrapperItem} style={{ marginTop: "10px" }}>
                <div className={styles.heatmapTooltipWrapperItemFirst}>{"Count: "}</div>
                <div className={styles.heatmapTooltipWrapperItemSecond}>{columnCount}</div>
              </div>
            </div>
          ) : (
            <React.Fragment>
              <div className={styles.popItem}>
                <div className={styles.popFirst}>{column + ":"}</div>
                <div className={styles.popSecond}>{value}</div>
              </div>
              <div className={styles.popItem}>
                <div className={styles.popFirst}>{"Average: "}</div>
                <div className={styles.popSecond}>{retScore * 100 + "%"}</div>
              </div>
              <div className={styles.popItem} style={{ marginTop: "10px" }}>
                <div className={styles.popFirst}>{"Count: "}</div>
                <div className={styles.popSecond}>{columnCount}</div>
              </div>
            </React.Fragment>
          )}
        </Popover>
      </Overlay>
      <div
        className={styles.dashGridCell}
        style={{
          minWidth: `${100 / chart.lineKeys.length}%`,
          background: baseColor.replace("1)", Math.abs(adjustedScore) + ")")
        }}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      ></div>
    </React.Fragment>
  );
};
